export const Images = {
  LoginImage: "/images/arrow.svg",
  SignUpImage: "/images/arrow.svg",
  Logo: "/images/bgbluelogo.png",
  Arrow: "/images/arrow.svg",
  userImage: "/images/logo.jpg",
  Eye: "/images/eye.svg",
  Edit: "/images/edit.svg",
  Call: "/images/call.svg",
  Time: "/images/time.svg",
  Cross: "/images/cross.svg",
  CrossBlack: "/images/cross-black.svg",
  Calender: "/images/calender.svg",
  Email: "/images/email.svg",
  Upload: "/images/upload-outline.svg",
  ErrorImage: "/images/error-image.svg",
  SearchImage: "/images/search-image.svg",
  NotFound: "/images/notfound_page.svg",
  Send: "/images/send.svg",
  Reminder: "/images/reminder.svg",
  Family: "/images/family.svg",
  Filter: "/images/filter.svg",
  // Excel: "/sample-sheet.xlsx", 
  Delete: "/images/delete.svg",
  BookingIcon: "/images/booking-icon.svg",
  Mtn: "/images/mtn.png",
  Vodafone: "/images/vodafone.png",
  Airtel: "/images/airtel.png",
  Create: "/images/create.svg",
  ViewList: "/images/ViewList.svg",
  Avatar: "/images/avatar.png",
  FooterImg: "/images/footer-jpg.jpg",
  KualitySignTransparent: "/KualitySignTransparent.png",
  smartphones: "/images/smartphones.png",
  ImagePlaceholder: "/images/image-placeholder.png",
  ImagePlaceholder2: "/images/image-placeholder-2.png",
};

export default Images;
